// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"91e92828","703":"6e298146","787":"708d4e92"}[chunkId] + ".chunk.js";
};